module.exports = __webpack_public_path__ + "img/attach.a1da392f.svg";